<template>
  <div id="order-status-modal" class="modal"  v-show="modalShown">
    <div class="modal-main">
      <div class="title-area">
        <h2>ステータス変更</h2>
      </div>
      <div v-if="isCheckPlan">
        <!-- ローディングモーダル -->
        <dd-loading-modal ref="loadingModalRef" />
        <div class="data-area">
          <ul>
            <li v-if="isSketchList">
              <div>
                <span class="label">返信コメント</span>
                <textarea v-model="resultSketchComment"/>
              </div>
            </li>
            <li v-if="isSalesList">
              <div class="sales-label">営業中：受注確率</div>
            </li>
            <li v-if="isSalesList">
              <label><input type="radio" v-model.number="planStatus" value=7>受注</label>
            </li>
            <li v-if="isSalesList">
              <label><input type="radio" v-model.number="planStatus" value=1 :disabled="isOriginalCorpPlan">A（高）</label>
            </li>
            <li v-if="isSalesList">
              <label><input type="radio" v-model.number="planStatus" value=2 :disabled="isOriginalCorpPlan">B（中）</label>
            </li>
            <li v-if="isSalesList">
              <label><input type="radio" v-model.number="planStatus" value=3 :disabled="isOriginalCorpPlan">C（低）</label>
            </li>
            <li v-if="isSalesList">
              <label><input type="radio" v-model.number="planStatus" value=9>受注確定（工場発注）</label>
              <div>
                <span class="label">受注処理日</span>
                <input type="date" v-model="orderDate">
              </div>
              <div>
                <span class="label">確定納品日</span>
                <input type="date" v-model="planDeliveryDate"/>
              </div>
              <div>
                <span class="label">特記事項</span>
                <textarea v-model="orderComment"/>
              </div>
              <!-- add DCD-451 20230831 start -->
              <label><input type="radio" v-model.number="planStatus" value=50>生産完了</label>
              <div>
                <span class="label">生産完了日</span>
                <input type="date" v-model="shipCompleteDate"/>
              </div>
              <label><input type="radio" v-model.number="planStatus" value=55>納品完了</label>
              <div>
                <span class="label">納品完了日</span>
                <input type="date" v-model="deliveryCompleteDate"/>
              </div>
              <!-- add DCD-451 20230831 end -->
            </li>
            <li v-if="isConfirmedOrderList">
              <label><input type="radio" v-model.number="planStatus" value=20 :disabled="updateOnlyDeliveryDate">生産計画済</label>
              <div>
                <span class="label">生産予定日</span>
                <input type="date" v-model="manufactureDate" :disabled="updateOnlyDeliveryDate"/>
              </div>
              <div>
                <span class="label">製造ロット</span>
                <input type="number" v-model.number="rotCode" min="1" max="99" :disabled="updateOnlyDeliveryDate"/>
              </div>
            </li>
            <li v-if="isManufactureList">
              <label><input type="radio" v-model.number="planStatus" value=50 :disabled="updateOnlyDeliveryDate">生産完了</label>
              <div>
                <span class="label">生産完了日</span>
                <input type="date" v-model="shipCompleteDate" :disabled="updateOnlyDeliveryDate"/>
              </div>
            </li>
            <li v-if="isManufactureList">
              <label><input type="radio" v-model.number="planStatus" value=55 :disabled="updateOnlyDeliveryDate">納品完了</label>
              <div>
                <span class="label">納品完了日</span>
                <input type="date" v-model="deliveryCompleteDate" :disabled="updateOnlyDeliveryDate"/>
              </div>
            </li>
            <hr v-if="isConfirmedOrderList || isManufactureList">
            <li v-if="isConfirmedOrderList || isManufactureList">
              <div>
                <input type="checkbox" v-model="updateOnlyDeliveryDate">
                <span class="label">確定納品日のみ変更</span>
              </div>
              <div>
                <span class="label">確定納品日</span>
                <input type="date" v-model="planDeliveryDate"/>
              </div>
            </li>
            <li v-if="isSalesList">
              <label><input type="radio" v-model.number="planStatus" value=60>失注</label>
            </li>
            <li v-if="isSalesList">
              <label><input type="radio" v-model.number="planStatus" value=70>対象外</label>
            </li>
            <li v-if="isSalesList">
              <label><input type="radio" v-model.number="planStatus" value=61>キャンセル</label>
            </li>
          </ul>
        </div>
        <div v-for="(errorMessage, idx) in errorMessages" :key="idx" class="error_message">
          {{ errorMessage }}
        </div>
        <p class="error_message" v-for="(errorMessage, idx) in validateErrorMessages" :key="idx">
          {{ errorMessage }}
        </p>
        <div class="button-area">
          <button type="button" class="main_btn" @click="confirmUpdate">確定</button>
          <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
        </div>
      </div>
      <div v-else class="non_selected">
        <div class="data-area">
          <span>プランが選択されていません。</span>
        </div>
        <div class="button-area">
          <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import * as Api from '../../../utils/Api'
import * as AppUtil from '../../../utils/App'
import {API_URL} from '../../../constants/App'
import {PLAN_STATUS} from '../../../constants/Type'
import LoadingModal from '../../common/LoadingModal'

export default {
  name: 'PlanOrderStatusModal',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
    orderStatusData: Object,
    checkedPlans: Array,
    isSketchList: Boolean,
    isSalesList: Boolean,
    isConfirmedOrderList: Boolean,
    isManufactureList: Boolean
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      /** 選択ステータス */
      planStatus: 0,
      /** スケッチオーダーコメント */
      resultSketchComment: '',
      /** 受注日 */
      orderDate: '',
      /** 納期 */
      planDeliveryDate: '',
      /** 特記事項 */
      orderComment: '',
      /** 製造ロット */
      rotCode: '',
      /** 生産予定日 */
      manufactureDate: '',
      /** 生産完了日 */
      shipCompleteDate: '',
      /** 納品完了日 */
      deliveryCompleteDate: '',
      /** 確定納品日のみ変更フラグ */
      updateOnlyDeliveryDate: false,
      /** 編集中データ */
      editData: null,
      errorMessages: [],
      validateErrorMessages: {}
    }
  },
  computed: {
    isCheckPlan: function () {
      return !((this.isConfirmedOrderList || this.isManufactureList) && (!this.checkedPlans || !this.checkedPlans.length > 0))
    },
    isOriginalCorpPlan: function () {
      if (!this.editData) return false
      let user = AppUtil.getUserInfo()
      return user.corpId !== this.editData.corpId && user.corpId === this.editData.originalCorpId
    }
  },
  methods: {
    /** 新規モーダル */
    showModal: function (data) {
      this.editData = data
      if (this.isSalesList && this.editData) {
        this.planStatus = this.editData.planStatus
        this.planDeliveryDate = this.getFormatDate(this.editData.planDeliveryDate)
      } else if (this.isConfirmedOrderList) {
        this.planStatus = PLAN_STATUS.MANUFACTURE.code
      } else if (this.isManufactureList) {
        this.planStatus = PLAN_STATUS.SHIP_COMPLETE.code
      } else if (this.isSketchList) {
        this.planStatus = PLAN_STATUS.SKETCH_ORDER.code
      }
      this.modalShown = true
      this.setDefaultDate()
    },
    /** キャンセル */
    onCancel: function () {
      this.modalShown = false
      this.crearData()
    },
    /** ステータス更新確認 */
    confirmUpdate: function () {
      this.formValidate()
      if (this.errorMessages.length > 0) { return }
      let modalData = {
        messages: ['本当に変更しますか？'],
        modalType: 'confirm',
        textAlign: 'left',
        onOk: this.updateStatus
      }
      AppUtil.showModal(modalData)
    },
    /** ステータス更新 */
    updateStatus: function () {
      if (this.isSalesList) {
        this.updatePlanStatus()
      } else if (this.isConfirmedOrderList) {
        this.updatePlanListStatus()
      } else if (this.isManufactureList) {
        this.updatePlanListStatus()
      } else if (this.isSketchList) {
        this.updateSketchPlanStatus()
      }
    },
    /** スケッチオーダーステータス更新 */
    updateSketchPlanStatus: function () {
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        fdId: this.editData.fdId,
        spaceJoincd: this.editData.spaceJoincd,
        planStatus: this.planStatus,
        sketchComment: this.resultSketchComment
      }
      axios.post(API_URL.LIST + '/status/updateSketch', payload
      ).then(response => {
        this.$refs.loadingModalRef.showModal(false)
        let modalData = {
          messages: ['カートに追加しました'],
          onOk: () => {
            this.modalShown = false
            this.crearData()
            this.$emit('getSketchList', false)
          }
        }
        this.validateErrorMessages = {}
        AppUtil.showModal(modalData)
      }).catch(error => {
        this.$refs.loadingModalRef.showModal(false)
        this.validateErrorMessages = {}
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    },
    /** 単一プラン ステータス更新 */
    updatePlanStatus: function () {
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        fdId: this.editData.fdId,
        spaceJoincd: this.editData.spaceJoincd,
        planStatus: this.planStatus,
        orderDate: this.orderDate,
        planDeliveryDate: this.planDeliveryDate,
        shipCompleteDate: this.shipCompleteDate, // 生産完了 // add DCD-451 20230831
        deliveryCompleteDate: this.deliveryCompleteDate, // 納品完了 // add DCD-451 20230831
        orderComment: this.orderComment,
        originalCorpId: this.editData.originalCorpId
      }
      axios.post(API_URL.LIST + '/status/update', payload
      ).then(response => {
        this.$refs.loadingModalRef.showModal(false)
        let modalData = {
          messages: ['変更しました'],
          onOk: () => {
            this.modalShown = false
            this.crearData()
            this.$emit('getSalesList', false)
          }
        }
        this.validateErrorMessages = {}
        AppUtil.showModal(modalData)
      }).catch(error => {
        this.$refs.loadingModalRef.showModal(false)
        this.validateErrorMessages = {}
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    },
    /** 複数プラン ステータス更新 */
    updatePlanListStatus: function () {
      this.$refs.loadingModalRef.showModal(true)
      let joincdList = this.checkedPlans.map(plan => plan.spaceJoincd)
      let payload = {
        spaceJoincdList: joincdList,
        planStatus: this.planStatus,
        manufactureDate: this.manufactureDate,
        shipCompleteDate: this.shipCompleteDate,
        deliveryCompleteDate: this.deliveryCompleteDate,
        rotCode: this.rotCode,
        planDeliveryDate: this.planDeliveryDate
      }
      // 確定納品日のみ変更
      if (this.updateOnlyDeliveryDate) {
        payload = {
          spaceJoincdList: joincdList,
          planDeliveryDate: this.planDeliveryDate
        }
      }
      axios.post(API_URL.LIST + '/status/update/plans', payload
      ).then(response => {
        this.$refs.loadingModalRef.showModal(false)
        let modalData = {
          messages: ['変更しました'],
          onOk: () => {
            this.modalShown = false
            this.crearData()
            if (this.isConfirmedOrderList) {
              this.$emit('getConfirmedOrderList', false)
            } else if (this.isManufactureList) {
              this.$emit('getManufactureList', false)
            }
          }
        }
        this.validateErrorMessages = {}
        AppUtil.showModal(modalData)
      }).catch(error => {
        this.$refs.loadingModalRef.showModal(false)
        this.validateErrorMessages = {}
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    },
    /** バリデーションチェック */
    formValidate: function () {
      this.errorMessages = []
      // 確定納品日のみ変更
      if (this.updateOnlyDeliveryDate) {
        if (!this.planDeliveryDate) {
          this.errorMessages.push('確定納品日を指定してください。')
        }
      // 受注確定処理
      } else if (this.planStatus === PLAN_STATUS.ORDER_CONFIRMED.code) {
        if (!this.orderDate) {
          this.errorMessages.push('受注処理日を指定してください。')
        }
      // 生産計画処理
      } else if (this.isConfirmedOrderList && this.planStatus === PLAN_STATUS.MANUFACTURE.code) {
        if (!this.manufactureDate) {
          this.errorMessages.push('生産予定日を指定してください。')
        }
        if (!this.rotCode) {
          this.errorMessages.push('製造ロットを入力してください。')
        } else if (this.rotCode < 1 || this.rotCode > 99) {
          this.errorMessages.push('製造ロットは1以上99以下で入力してください。')
        }
      // 生産完了処理
      } else if (this.planStatus === PLAN_STATUS.SHIP_COMPLETE.code) {
        if (!this.shipCompleteDate) {
          this.errorMessages.push('生産完了日を指定してください。')
        }
      // 納品完了処理 // add DCD-451 20230831
      } else if (this.planStatus === PLAN_STATUS.DELIVERY_COMPLETE.code) {
        if (!this.deliveryCompleteDate) {
          this.errorMessages.push('納品完了日を指定してください。')
        }
      }
    },
    crearData: function () {
      let today = this.getFormatDate(new Date())
      this.resultSketchComment = ''
      this.orderDate = today
      this.manufactureDate = today
      this.shipCompleteDate = today
      this.planDeliveryDate = ''
      this.orderComment = ''
      this.rotCode = ''
      this.updateOnlyDeliveryDate = false
      this.errorMessages = []
    },
    setDefaultDate: function () {
      let today = this.getFormatDate(new Date())
      this.orderDate = today
      this.manufactureDate = today
      this.shipCompleteDate = today
      this.deliveryCompleteDate = today
    },
    getFormatDate: function (date) {
      if (date) {
        return moment(date).format('YYYY-MM-DD')
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
li{
  margin-bottom: 10px;
  text-align: left;
  div{
    padding: 10px;
    text-align: left;
  }
  .label{
    min-width: 100px;
    display: inline-block;
    text-align: left;
  }
  .sales-label {
    font-weight: bold;
    margin-top: 15px;
  }
}
.data-area {
  padding: 20px;
  max-height: 620px;
  overflow: auto;
}
.modal-main{
  max-height: 100%;
  max-width: 350px;
}
.non_selected {
  margin: 0 auto
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/modal/PlanOrderStatusModal.vue